import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  dialogTitle: {
    color: theme.palette.blue_300.main
  },

  contentFormGroup: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: '10px'
  },
  formControl:{
    display: 'flex',
    gap: '8px'
  },
  formLabel: {
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main,
    margin: '0',
  },
  boxGrid: {
    border:
      theme.palette.type === 'dark'
        ? '1px solid' + theme.palette.dark_stroke.main
        : '1px solid' + theme.palette.gray_stroke.main,
    borderRadius: 16,
    padding: '10px !important',
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.palette.dark_400.main
        : theme.palette.gray_100.main
  },
  groupTitle: {
    margin: 0,
    color: theme.palette.blue_300.main,
    fontWeight: '600',
    marginBottom: '12px'
  },
  boxContentInput: {
    display: 'flex',
    gap: '8px',
    marginBottom: '8px'
  },
  helpButton: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    cursor: 'pointer',
    justifyContent: 'space-between'
  },
  inputButtonHelp: {
    color: theme.palette.blue_300.main,
    backgroundColor: 'transparent',
    '&:hover': {
      backgroundColor: 'transparent'
    }
  },
  boxPopover: {
    padding: 10,
    width: '300px',
    minWidth: '300px',
    fontSize: '1rem',
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.palette.dark_600.main
        : theme.palette.gray_100.main,
    borderRadius: 8,
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main
  },

  inputWrapper: {
    display: 'flex',
    gap: '8px',
    alignItems: 'center'
  },
  textUntil: {
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main
  },
  contentFormGrid: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '8px'
  },
  boxShowWeekTime: {
    border:
      theme.palette.type === 'dark'
        ? '1px solid' + theme.palette.dark_stroke.main
        : '1px solid' + theme.palette.gray_stroke.main,
    borderRadius: 16,
    padding: '10px !important'
  },

  queueContainer: {
    display: 'flex',
    gap: '8px',
    margin: '8px 0'
  },
  queueItem: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '10px',
    // gap: '8px',
    border:
      theme.palette.type === 'dark'
        ? '1px solid' + theme.palette.dark_stroke.main
        : '1px solid' + theme.palette.gray_stroke.main,
    borderRadius: 10,
    minWidth: '120px',
    cursor: 'pointer',
    height: '40px',
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main
  },
  iconButton: {
    backgroundColor: 'transparent',
    color: theme.palette.blue_300.main,
    padding: 0,
    '&:hover': {
      backgroundColor: 'transparent'
    }
  }
}))
